<template>
  <div class="dropdown d-inline-flex align-items-center gap-1" ref="rootEl">
    <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
            type="button"
            :id="id"
            :aria-expanded="isOpen"
            @click="isOpen = !isOpen">
      {{ label }}<span v-if="modelValue.length">&nbsp;({{ modelValue.length }})</span>
    </button>
    <i v-if="modelValue.length"
       class="bi bi-x-circle-fill clear-icon"
       role="button"
       :aria-label="`Zrušit filtr ${label}`"
       :title="`Zrušit filtr ${label}`"
       @click.stop="clear"></i>
    <ul class="dropdown-menu" :class="{show: isOpen}" :aria-labelledby="id">
      <li v-if="modelValue.length">
        <button type="button" class="dropdown-item text-danger" @click="clear">
          <i class="bi-x-circle"></i>&nbsp;Zrušit filtr
        </button>
      </li>
      <li v-if="modelValue.length"><hr class="dropdown-divider"></li>
      <li v-for="option in options" :key="option.value" class="px-3 py-1">
        <label class="form-check-label d-flex align-items-center gap-2">
          <input type="checkbox"
                 class="form-check-input"
                 :checked="isChecked(option.value)"
                 @change="toggle(option.value)">
          {{ option.label }}
        </label>
      </li>
      <li v-if="!options.length" class="px-3 py-1 text-muted">Žádné možnosti</li>
    </ul>
  </div>
</template>

<script setup>
import {ref, onMounted, onUnmounted, defineProps, defineEmits} from 'vue'

const props = defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const isOpen = ref(false);
const rootEl = ref(null);

const isChecked = (value) => props.modelValue.includes(value);

const toggle = (value) => {
  if (isChecked(value)) {
    emit('update:modelValue', props.modelValue.filter(v => v !== value));
  } else {
    emit('update:modelValue', [...props.modelValue, value]);
  }
};

const clear = () => {
  emit('update:modelValue', []);
};

// zavření dropdownu při kliknutí mimo komponentu (bootstrap.bundle.js s Popperem
// není v aplikaci načtený, takže se otevírání/zavírání řeší ručně)
const handleClickOutside = (event) => {
  if (isOpen.value && rootEl.value && !rootEl.value.contains(event.target)) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('mousedown', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('mousedown', handleClickOutside);
});
</script>

<style scoped>
.dropdown-menu {
  max-height: 320px;
  overflow-y: auto;
}

.clear-icon {
  cursor: pointer;
  color: #adb5bd;
}

.clear-icon:hover {
  color: var(--bs-danger);
}
</style>
